'use client'

import { AffiliateTracker } from '@/lib/tracking/affiliate-tracker'
import { useEffect } from 'react'

export function TrackingProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Make sure we're on the client side
    if (typeof window === 'undefined') return

    // Get the current URL and create URLSearchParams
    const url = new URL(window.location.href)
    const urlSearchParams = url.searchParams

    // Initialize affiliate tracking
    const tracker = AffiliateTracker.getInstance()
    tracker.init(urlSearchParams)
  }, []) // Only run once on mount

  return <>{children}</>
}
